<template>
                <div v-if="currentView === 'branding'">
                    <div class="page-header"><div><div class="page-title">外觀設定</div><div class="page-subtitle">品牌標誌、顯示名稱與系統顏色個人化</div></div></div>
                    <div class="rounded border p-6 space-y-6 max-w-2xl" style="background:var(--surface);border-color:var(--border);">
                        <div>
                            <label class="block text-sm font-bold mb-1" style="color:var(--gray-700);">登入頁面標題</label>
                            <input v-model="brandingForm.loginTitle" type="text" class="input" placeholder="例如：公司名稱登入" />
                            <div class="mt-2">
                                <button @click="saveBrandingText('ui_login_title', brandingForm.loginTitle)" class="btn btn-primary">儲存登入標題</button>
                            </div>
                        </div>
                        <div>
                            <label class="block text-sm font-bold mb-1" style="color:var(--gray-700);">左上角標題</label>
                            <input v-model="brandingForm.headerTitle" type="text" class="input" placeholder="例如：公司郵件系統" />
                            <div class="mt-2">
                                <button @click="saveBrandingText('ui_header_title', brandingForm.headerTitle)" class="btn btn-primary">儲存左上角標題</button>
                            </div>
                        </div>
                        <div>
                            <label class="block text-sm font-bold mb-1" style="color:var(--gray-700);">左上角 Logo</label>
                            <div class="flex items-center gap-4">
                                <img v-if="brandingForm.headerLogoUrl" :src="brandingForm.headerLogoUrl" alt="logo-preview" class="h-10 w-auto border rounded p-1 bg-white" />
                                <input v-model="brandingForm.headerLogoUrl" type="text" class="flex-1 border rounded px-3 py-2" placeholder="/static/resources/xxxx.png 或完整 URL" />
                            </div>
                            <div class="mt-2 flex items-center gap-2">
                                <input type="file" @change="uploadBrandLogo" />
                                <button @click="applyHeaderLogoUrl" class="btn btn-primary">套用 Logo URL</button>
                            </div>
                        </div>
                    </div>
                </div>


</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useAppStore } from '../store/app.js'

const store = useAppStore()

// Spread all store state as reactive refs accessible in template
const stateRefs = storeToRefs(store)
// Destructure - Vue compiler exposes all variables declared in <script setup> to template
const {
  // Core state
  token, currentView, currentUser, loginForm, loginError,
  branding, brandingForm, notifications, showNotifPanel,
  // Command palette
  showCmdPalette, cmdQuery, cmdResults, cmdGrouped, cmdDefaults, cmdSelIdx,
  // Domain / Users / Departments
  domains, domainForm, showDomainForm, domainLoading,
  users, userForm, showUserForm, userLoading, userError,
  departments, deptForm, showDeptForm, deptLoading,
  // Contacts / Groups
  contacts, contactForm, showContactForm, contactLoading,
  groups, groupForm, showGroupForm, groupLoading,
  // Mail
  mailQueues, mailQueueLoading, mailQueueFilter,
  serviceStatus, serviceLoading,
  // Invoice Drive
  invoiceDriveState,
  // Quotes / Products
  quotes, quoteForm, showQuoteForm, quoteLoading,
  products, productForm, showProductForm, productLoading,
  priceBooks, priceBookForm, showPriceBookForm,
  // SSL
  sslCerts, sslLoading, sslDomain,
  // Security
  securityWizardStep, spamStats,
  securityFilterState,
  // Server settings
  serverMailSettings, serverDnsSettings, serverDbSettings, serverAiSettings,
  backupSettings,
  // Logs / Audit
  logs, logFilter, logLoading,
  mailAuditRecords, auditFilter, auditLoading,
  securityAuditLogs, securityAuditFilter,
  logAnalysisResult, logAnalysisLoading,
  // AI / RAG / Sales
  ragState, aiSalesState, aiMarketingState,
  // LINE
  lineSupportState,
  // Webmail
  webmailState, webmailAutoScanInvoices, webmailAutoScanMarkRead,
  // Unreplied
  unrepliedEmails, unrepliedLoading,
  // CBI
  cbiInsights, cbiLoading,
  // Misc
  sidebarCollapsed, sidebarMobile,
  journeyEnrollments, journeyEnrollmentsLoading,
  journeyFunnel, journeyFunnelLoading, journeyFunnelFilters,
  showJourneyEditorModal, showJourneyFunnelModal, showJourneyEnrollmentsModal,
  selectedJourneyForEnrollments, selectedJourneyForFunnel,
  journeyEditorForm,
} = stateRefs

// Methods are accessed directly from store (not reactive, no storeToRefs needed)
const {
  login, logout, switchSidebarView, canAccess,
  openCommandPalette, closeCmdPalette, updateCmdResults, execCmdItemById,
  moveCmdSel, toggleNotifPanel, markNotifRead, clearNotifs,
  fetchDomains, saveDomain, deleteDomain,
  fetchUsers, saveUser, deleteUser, resetUserPassword,
  fetchDepartments, saveDepartment, deleteDepartment,
  fetchContacts, saveContact, deleteContact, importContacts,
  fetchGroups, saveGroup, deleteGroup,
  fetchMailQueue, releaseMailQueueItem, deleteMailQueueItem, flushMailQueue,
  fetchServiceStatus, fetchSpamStats,
  fetchSslCerts, issueSslCert, deleteSslCert,
  fetchProducts, saveProduct, deleteProduct,
  fetchPriceBooks, savePriceBook, deletePriceBook,
  fetchQuotes, saveQuote, deleteQuote, sendQuote,
  fetchLogs, fetchLogAnalysis,
  fetchMailAuditRecords, fetchSecurityAuditLogs,
  fetchServerMailSettings, saveServerMailSettings,
  fetchServerDnsSettings, saveServerDnsSettings,
  fetchServerDbSettings, saveServerDbSettings,
  fetchServerAiSettings, saveServerAiSettings,
  fetchBackupSettings, saveBackupSettings, triggerBackup,
  fetchSecurityFilter, saveSecurityFilter,
  fetchRagDocuments, uploadRagDocument, deleteRagDocument, queryRag,
  fetchUnreplied,
  fetchCbiInsights,
  loadBrandingFromLocal, saveBranding, saveBrandingText,
  safeArr, keyById,
  invoiceDriveCanGotoAdjacent, invoiceDriveGotoAdjacent,
  openInvoiceDetail, closeInvoiceDetail,
} = store
</script>

